<template>
  <v-tooltip right>
    <template #activator="{ attrs, on }">
      <avatar
        color="grey lighten-3"
        :small="small"
        :class="nudgeLeft"
        v-bind="attrs"
        :on="on"
      >
        +{{ count }}
      </avatar>
    </template>
    <div v-for="researcher in researchers" :key="researcher.id">
      {{ researcher.name }}
    </div>
  </v-tooltip>
</template>

<script>
import Avatar from './Avatar';
import { Researcher } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ResearcherAvatarOverflow',
  components: { Avatar },
  props: {
    researchers: {
      type: Array,
      required: true,
      validator: (field) =>
        typeHelpers.isArrayOfType(field, Researcher),
    },
    medium: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    count() {
      return this.researchers.length;
    },
    nudgeLeft() {
      return this.small ? 'ml-n1' : 'ml-n3';
    },
  },
};
</script>
